import { Navigate, Route, Routes } from "react-router-dom";
import HomeRoute from "./routes/HomeRoute";
import DeepLinkRoute from "./routes/DeepLinkRoute";
import PaymentsDeepLinkRoute from "./routes/PaymentsDeepLinkRoute";

const AppRouter = (): JSX.Element => {
  return (
    <div id="App" data-testid="app-router-component">
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<HomeRoute />} />

        <Route path="/:department/:setupKey" element={<DeepLinkRoute />} />

        <Route
          path="/payments/:department/:setupKey"
          element={<PaymentsDeepLinkRoute />}
        />

        <Route path="*" element={<>The requested page was not found.</>} />
      </Routes>
    </div>
  );
};

export default AppRouter;
